import { apolloClient } from "../../../vue-apollo";
import { GET_MODULES_ADMIN_PRIVILEGIOS, GET_EMPRESAS_EXCLUSIVAS } from "@/apollo/queries";
export default {
  namespaced: true,
  state: { modules: [], empresasExclusivas: [] },
  mutations: {
    SET_MODULES(state, res) {
      
      let empresa = JSON.parse(
        localStorage.getItem("vuejs__user_empresa")
      ).value;      
      if (localStorage.getItem("vuejs__user") && empresa) {
        if (empresa.id_plan_fk == "21" || empresa.id_plan_fk == 21) {
          state.modules = res.filter(({ id_detalle }) => id_detalle !== "0");
        } else {
          state.modules = res;
        }
      }
    },
    SET_EMPRESAS_EXCLUSIVAS(state, res) {
      state.empresasExclusivas = [...res];
    },
  },
  getters: {
    userHasVideoModule(state) {
      const { modules } = state;
      return modules.some((module) => module.moduloGeneral.id_modulo == "6");
    },
    userHasOnlyOneModule(state) {
      const { modules } = state;
      return (
        modules.length === 1 ||
        (modules.length === 2 &&
          modules.some((module) => module.moduloGeneral.id_modulo === "1"))
      );
    },
		userHasInicio(state) {
      const { modules } = state;
      return modules.some((module) => module.moduloGeneral.id_modulo === "1")
    },
    userHasMuralDigitalButNotNews(state) {
      const { modules } = state;
      const hasMuralDigital = modules.some(
        (module) => module.moduloGeneral.id_modulo == "24"
      );
      const hasNews = modules.some(
        (module) => module.moduloGeneral.id_modulo == "3"
      );
      return hasMuralDigital && !hasNews;
    },
    userHasReconoceModule(state) {
      const { modules } = state;
      return modules.some((module) => module.moduloGeneral.id_modulo == "4");
    },
  },
  actions: {
    async getModules({ commit,dispatch }, data_) {
      const params = {
        query: GET_MODULES_ADMIN_PRIVILEGIOS,
        variables: data_,
      };
      dispatch("getEmpresasExclusivas")
      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.modulosAdminUpdated;

        response.forEach((module) => {
          module.visitas = 0;
        });
        commit("SET_MODULES", response);
      } catch (error) {
        console.error("Error de obteniendo lista de módulos", error);
      }
      return response;
    },
    async getEmpresasExclusivas({ commit }) {
      const params = {
        query: GET_EMPRESAS_EXCLUSIVAS,
      };

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.GetEmpresasExclusivas;
        commit("SET_EMPRESAS_EXCLUSIVAS", response);
      } catch (error) {
        console.error("Error de obteniendo lista de empresas exclusivas", error);
      }
      return response;
    }
    
  },
};
